import type { TFunction } from 'i18next';

/**
 * GraphQLExceptionHandler 会把 basic 侧 messageKey 原样透传到 error.message。
 * 若 key 在 i18n 中有翻译则用译文，否则回退到兜底文案，避免页面直接弹出
 * `errors.validation.basic.dlcc.xxx` 这种原始 key。
 */
export function resolveLearningCenterErrorMessage(
  err: any,
  t: TFunction,
  fallbackKey = 'learningCenterConfig.messages.operationFailed',
): string | null {
  // 纯网络错误（无 graphQLErrors）已由全局 Apollo errorLink 弹出"网络连接错误"提示，
  // 此处返回 null 避免重复弹出浏览器原生的 "Failed to fetch" 等英文错误信息。
  if (err?.networkError && !err?.graphQLErrors?.length) {
    return null;
  }

  const raw =
    err?.graphQLErrors?.[0]?.extensions?.message
    || err?.graphQLErrors?.[0]?.message
    || err?.message;

  if (!raw || typeof raw !== 'string') {
    return String(t(fallbackKey));
  }

  if (raw.startsWith('errors.')) {
    const translated = t(raw);
    if (translated && translated !== raw) {
      return translated;
    }
    // raw 是一个 i18n key 但没有对应翻译词条：不能把 key 本身当文案展示给用户
    return String(t(fallbackKey));
  }

  return raw;
}
